import { makePostApiCall } from "../../shared/makeApiCall";

export type AuditRestoreResponse = {
  message: string;
  warnings: string[];
};

export async function restoreFromAudit(auditId: number | string) {
  return makePostApiCall("restoreFromAudit", { audit_id: auditId });
}
